//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            occupantModel: [],
            check_role: false,
            CoApplicants: [],
            residentSettings: {
                prospect_id: 0,
                nestio_id: 0
            },
            contactLoading: false,
            leaseLoading: false,
            emergencyLoading: false,
            petLoading: false,
            vehicleLoading: false,
            CoApplicantLoading: false,
            occupantsLoading: false,
            basicLoading: false,
            consentLoading: false,
            residentLoading: false,
            servicesLoading: false,
            flagsLoading: false,
            editArNotes: false,
            emptyArNotes: false,
            arLoading: false,
            generalLoading: false,
            arAudit: {
                user: {
                    full_name: ''
                }
            },
            ar_notes: null,
            editGeneralNotes: false,
            emptyGeneralNotes: false,
            generalAudit: {
                user: {
                    full_name: ''
                }
            },
            general_notes: null,
            percent: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '%',
                precision: 2,
                masked: false
            },
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: 2,
                masked: false
            },
            sources: ['Drive by', 'Resident referral', 'Former resident referral', 'Employee referral', 'Other word of mouth', 'Other Community referral', 'Google', 'Property website', 'Zillow', 'Trulia', 'Costar', 'Rentpath', 'Craigs list', 'Facebook Marketplace', 'Apartment Locator service', 'Flyer, Radio, Newspaper advertisement'],
            devices: ['Gate Opener', 'Garage Opener'],
            additionalIncomeType: ['Rent', 'Other'],
            contact_preferences: ['SMS', 'Email', 'Phone'],
            concessionOptions: ['Reserved Parking', 'Tech Package', 'Rent'],
            policyTypes: ['Fortegra Master', 'HO4'],
            rentalPolicyStatus: ['Active', 'Expired', 'Canceled'],
            editContact: false,
            editLease: false,
            editEmergency: false,
            editVehicle: false,
            editPetInformation: false,
            editOccupant: false,
            editBasic: false,
            editConsent: false,
            editCoApplicant: false,
            editResident: false,
            editService: false,
            person: {},
            rental_policy: {},
            occupants: [],
            vehicles: [],
            pets: [],
            services: [],
            lease: {},
            flags: {
                doNotRenew: false,
                earlyTermination: false,
                isLegacy: false,
                eligibleForLateFees: true
            },
            consent: true,
            concessions: [{
                name: 'Reserved Parking',
                type: 'Dollar Amount',
                amount: '25.00'
            }],
            allowedAdminUserRoles: ['super-admin', 'property-manager', 'leasing-consultant', 'regional-manager'],
            rolesForActiveResident: ['super-admin', 'corporate-admin', 'accounting-admin', 'regional-manager', 'property-manager', 'leasing-consultant', 'accounting-analyst'],
            rolesForPastResident: ['super-admin', 'corporate-admin', 'accounting-admin'],
            currentEmail: '',
            coResidentValidations: [],
            occupantsValidations: [],
            arNotesValidation: [{ model: 'ar_notes', rules: 'required' }],
            generalNotesValidation: [{ model: 'general_notes', rules: 'required' }]
        };
    },
    created: function created() {
        this.$initValidator();
        this.getResidentDetailsSettings();
        this.getUsers();
    },
    beforeDestroy: function beforeDestroy() {},

    methods: {
        getUsers: function getUsers() {
            var _this = this;

            axios.get('/prototype/users/all').then(function (response) {
                _this.users = response.data;
            });
        },
        getResidentDetailsSettings: function getResidentDetailsSettings() {
            var $el = this;
            $el.person = $el.resident.person;
            $el.person.consent = $el.person.consent == 1;
            $el.person.consent_spouse = $el.person.consent_spouse == 1;
            $el.person.consent_parent = $el.person.consent_parent == 1;
            this.emptyArNotes = !$el.resident.ar_notes;
            this.emptyGeneralNotes = !$el.resident.general_notes;
            $el.ar_notes = $el.resident.ar_notes;
            $el.general_notes = $el.resident.general_notes;
            $el.resident.do_not_renew_lease = $el.resident.do_not_renew_lease == 1;
            $el.resident.eligible_for_late_fees = $el.resident.eligible_for_late_fees == 1;
            $el.person.additional_income_amount = $el.resident.person.additional_income_amount ? $el.resident.person.additional_income_amount : 0;
            $el.residentSettings = $el.resident;
            $el.residentSettings.forwarding_address = $el.resident.forwarding_address ? $el.resident.forwarding_address : $el.resident.person.address;
            if ($el.resident.current_status === 'Move Out') {
                $el.residentSettings.resident_deposit_amount = $el.resident.unit && $el.resident.unit.past_resident_unit_lease ? $el.resident.unit.past_resident_unit_lease.resident_deposit_amount : 0;
            } else {
                $el.residentSettings.resident_deposit_amount = $el.resident.unit && $el.resident.unit.unit_lease ? $el.resident.unit.unit_lease.resident_deposit_amount : 0;
            }
            $el.currentEmail = $el.person.email;
            $el.prospect = $el.resident.person && $el.resident.person.prospect;
            if ($el.prospect) {
                $el.residentSettings.prospect_id = $el.prospect.id;
                $el.residentSettings.nestio_id = $el.prospect.nestio_id;
            }
            $el.residentSettings.source = $el.person.source;
            $el.residentSettings.selected_agent = $el.person.leasing_agent ? { 'id': $el.person.leasing_agent.id, 'label': '(' + $el.person.leasing_agent.id + ') ' + $el.person.leasing_agent.first_name + ' ' + $el.person.leasing_agent.last_name } : '';
            $el.check_role = window.user.role === 'super-admin';

            axios.post('/prototype/person/residents/get-resident-detail', { id: $el.person.id, residentId: $el.resident.id }).then(function (response) {
                if (response.data) {
                    if (response.data.vehicles) {
                        $el.vehicles = response.data.vehicles;
                    }
                    if (response.data.occupants) {
                        $el.occupants = response.data.occupants;
                    }
                    if (response.data.CoApplicants) {
                        $el.CoApplicants = response.data.CoApplicants;
                    }
                    if (response.data.pets) {
                        $el.pets = response.data.pets;
                    }
                    if (response.data.services) {
                        $el.services = response.data.services;
                    }
                    if (response.data.lease) {
                        $el.lease = response.data.lease;
                        $el.lease.move_in_date = moment($el.lease.move_in_date).format("MM/DD/YYYY");
                    }
                    if (response.data.arAudit) {
                        $el.arAudit = response.data.arAudit;
                    }
                    if (response.data.generalAudit) {
                        $el.generalAudit = response.data.generalAudit;
                    }
                    if (response.data.active_lease) {
                        $el.active_lease = response.data.active_lease;
                    }
                    if (response.data.rental_policy) {
                        $el.rental_policy = response.data.rental_policy;
                        $el.rental_policy.start_date = moment($el.rental_policy.start_date).format("MM/DD/YYYY");
                        $el.rental_policy.end_date = moment($el.rental_policy.end_date).format("MM/DD/YYYY");
                    } else {
                        $el.rental_policy.start_date = moment($el.lease.move_in_date).format("MM/DD/YYYY");
                        $el.rental_policy.end_date = moment($el.active_lease ? $el.active_lease.lease_expiration_date : $el.lease.lease_expiration_date).format("MM/DD/YYYY");
                    }
                }
            });
        },
        addConcession: function addConcession() {
            this.concessions.push({
                name: '',
                type: '',
                amount: ''
            });
        },
        addOccupant: function addOccupant() {
            this.occupants.push({
                occupant_first_name: '',
                occupant_last_name: ''
            });
        },
        addVehicle: function addVehicle() {
            this.vehicles.push({
                make: '',
                model: '',
                color: '',
                licence_plate: '',
                permit_number: '',
                state: '',
                parking: '',
                parking_number: ''
            });
        },
        addCoApplicant: function addCoApplicant() {
            this.CoApplicants.push({
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                social_security: '',
                birth_date: '',
                driver_license: '',
                driver_license_state: '',
                government_id: '',
                government_id_state: ''
            });
        },
        addAnimal: function addAnimal() {
            this.pets.push({
                kind: '',
                breed: '',
                name: ''
            });
        },
        updateContactInfo: function updateContactInfo() {
            this.contactLoading = true;
            this.update();
        },
        updateEmergencyInfo: function updateEmergencyInfo() {
            this.emergencyLoading = true;
            this.update();
        },
        updatePetInfo: function updatePetInfo() {
            var $el = this;
            this.petLoading = true;
            this.editPetInformation = true;

            axios.post('/prototype/person/residents/updatePet', { 'resident_id': this.resident.id, 'pets': JSON.stringify(this.pets) }).then(function (response) {
                if (response.data) {
                    $el.petLoading = false;
                    $el.editPetInformation = false;
                    $el.pets = response.data;
                }
            });
        },
        updateGeneralInformation: function updateGeneralInformation() {
            this.basicLoading = true;
            this.update();
        },
        updateConsent: function updateConsent() {
            this.consentLoading = true;
            this.update();
        },
        update: function update() {
            var _this2 = this;

            var $el = this;

            if ($el.currentEmail !== this.person.email && this.isUserAllowedToChangeEmail()) {
                this.$snotify.confirm('Changing the resident email will remove their bank accounts in the portal. Are you sure?', 'Warning!', {
                    timeout: 5000,
                    closeOnClick: false,
                    pauseOnHover: true,
                    buttons: [{ text: 'Yes', action: function action() {
                            _this2.$snotify.clear();
                            _this2.sendUpdateRequest();
                        }
                    }, { text: 'No', action: function action() {
                            _this2.$snotify.clear();
                            _this2.getResidentDetailsSettings();
                        }
                    }]
                });
            }

            this.sendUpdateRequest();
        },
        sendUpdateRequest: function sendUpdateRequest() {
            var $el = this;
            var _person = this.person,
                first_name = _person.first_name,
                last_name = _person.last_name,
                email = _person.email,
                work_phone = _person.work_phone,
                phone = _person.phone,
                contact_preference = _person.contact_preference,
                is_bond = _person.is_bond,
                emergency_contact = _person.emergency_contact,
                emergency_contact_phone = _person.emergency_contact_phone,
                emergency_contact_email = _person.emergency_contact_email,
                emergency_relationship = _person.emergency_relationship,
                emergency_address = _person.emergency_address,
                emergency_city = _person.emergency_city,
                emergency_state = _person.emergency_state,
                emergency_zip = _person.emergency_zip,
                emergency_home_phone = _person.emergency_home_phone,
                emergency_work_phone = _person.emergency_work_phone,
                former_name = _person.former_name,
                new_ssn = _person.new_ssn,
                driver_license = _person.driver_license,
                driver_license_state = _person.driver_license_state,
                government_id = _person.government_id,
                government_state = _person.government_state,
                additional_income_type = _person.additional_income_type,
                additional_income_amount = _person.additional_income_amount,
                consent = _person.consent,
                consent_spouse = _person.consent_spouse,
                consent_parent = _person.consent_parent,
                consent_alarm_code = _person.consent_alarm_code;

            var person = {
                first_name: first_name,
                last_name: last_name,
                email: email,
                contact_preference: contact_preference,
                phone: phone,
                work_phone: work_phone,
                is_bond: is_bond,
                emergency_contact: emergency_contact,
                emergency_contact_phone: emergency_contact_phone,
                emergency_contact_email: emergency_contact_email,
                emergency_relationship: emergency_relationship,
                emergency_address: emergency_address,
                emergency_city: emergency_city,
                emergency_state: emergency_state,
                emergency_zip: emergency_zip,
                emergency_home_phone: emergency_home_phone,
                emergency_work_phone: emergency_work_phone,
                former_name: former_name,
                new_ssn: new_ssn,
                driver_license: driver_license,
                driver_license_state: driver_license_state,
                government_id: government_id,
                government_state: government_state,
                additional_income_type: additional_income_type,
                additional_income_amount: additional_income_amount,
                consent: consent,
                consent_spouse: consent_spouse,
                consent_parent: consent_parent,
                consent_alarm_code: consent_alarm_code

            };
            axios.post('/prototype/person/residents/update-contact-info', { 'personData': JSON.stringify(person), 'id': this.person.id }).then(function (response) {
                if (response.data) {
                    $el.person = response.data;
                    $el.currentEmail = response.data.email;
                    $el.editContact = false;
                    $el.editEmergency = false;
                    $el.editPetInformation = false;
                    $el.editBasic = false;
                    $el.editConsent = false;
                    $el.contactLoading = false;
                    $el.emergencyLoading = false;
                    $el.petLoading = false;
                    $el.basicLoading = false;
                    $el.consentLoading = false;
                    Event.$emit('resident-list-dashboard-updated');
                    Event.$emit('update-resident-detail', $el.resident.id);
                }
            });
        },
        isUserAllowedToChangeEmail: function isUserAllowedToChangeEmail() {
            return window.user.role === 'super-admin' || window.user.role === 'property-manager' || window.user.role === 'leasing-consultant' || window.user.role === 'regional-manager';
        },
        updateVehicle: function updateVehicle() {
            var $el = this;
            this.vehicleLoading = true;

            axios.post('/prototype/person/residents/updateVehicle', { 'resident_id': this.resident.id, 'vehicles': JSON.stringify(this.vehicles) }).then(function (response) {
                if (response.data) {
                    $el.vehicleLoading = false;
                    $el.editVehicle = false;
                    $el.vehicles = response.data;
                }
            });
        },
        updateCoApplicant: function updateCoApplicant() {
            var _this3 = this;

            var $el = this;
            this.CoApplicants.map(function (charge, key) {
                var firstNameModel = 'CoApplicants.' + key + '.first_name';
                var lastNameModel = 'CoApplicants.' + key + '.last_name';
                var emailModel = 'CoApplicants.' + key + '.email';
                _this3.coResidentValidations.push({ model: firstNameModel, rules: 'required' }, { model: lastNameModel, rules: 'required' }, { model: emailModel, rules: 'required' });
            });

            this.validator.setRules(this.coResidentValidations).validate();

            if (this.validator.fails()) {
                return;
            }
            this.CoApplicantLoading = true;
            axios.post('/prototype/person/residents/updateCoApplicant', { 'resident_id': this.resident.id, 'CoApplicants': JSON.stringify(this.CoApplicants) }).then(function (response) {
                if (response.data) {
                    $el.CoApplicantLoading = false;
                    $el.editCoApplicant = false;
                    $el.CoApplicants = response.data;
                    $el.CoApplicants = $el.CoApplicants.map(function (applicant) {
                        applicant.birth_date = moment(applicant.birth_date).format("MM/DD/YYYY");
                        return applicant;
                    });
                }
            });
        },
        updateOccupants: function updateOccupants() {
            var _this4 = this;

            this.occupants.map(function (charge, key) {
                var firstNameModel = 'occupants.' + key + '.occupant_first_name';
                var lastNameModel = 'occupants.' + key + '.occupant_last_name';
                _this4.occupantsValidations.push({ model: firstNameModel, rules: 'required' }, { model: lastNameModel, rules: 'required' });
            });
            this.validator.setRules(this.occupantsValidations).validate();
            if (this.validator.fails()) {
                return;
            }
            var payLoad = [];
            this.occupants.map(function (occupant) {
                payLoad.push({ "first_name": occupant.occupant_first_name, "last_name": occupant.occupant_last_name, "id": occupant.id ? occupant.id : 0 });
            });
            var $el = this;
            this.occupantsLoading = true;

            axios.post('/prototype/person/residents/addOccupants', { 'person_id': this.person.id, 'occupant_name': JSON.stringify(payLoad) }).then(function (response) {
                if (response.data) {
                    $el.occupantsLoading = false;
                    $el.editOccupant = false;
                    $el.occupants = response.data.occupants;
                }
            });
        },
        updateResidentSetting: function updateResidentSetting() {
            var $el = this;
            this.residentLoading = true;

            axios.post('/prototype/person/residents/updateSettings', { 'resident_id': this.resident.id, 'residentSettings': JSON.stringify(this.residentSettings), 'nestio_id': this.residentSettings.nestio_id, 'prospect_id': this.residentSettings.prospect_id, 'source': this.residentSettings.source, 'selected_agent': this.residentSettings.selected_agent }).then(function (response) {
                if (response.data) {
                    $el.residentLoading = false;
                    $el.editResident = false;
                    $el.residentSettings = response.data;
                    $el.prospect = response.data.person && response.data.person.prospect;
                    if ($el.prospect) {
                        $el.residentSettings.prospect_id = $el.prospect.id;
                        $el.residentSettings.nestio_id = $el.prospect.nestio_id;
                    }
                    $el.residentSettings.source = response.data.person.source;
                    $el.leasing_agent = response.data.person && response.data.person.leasing_agent;
                    if ($el.leasing_agent) {
                        $el.residentSettings.selected_agent = { 'id': $el.leasing_agent.id, 'label': '(' + $el.leasing_agent.id + ') ' + $el.leasing_agent.first_name + ' ' + $el.leasing_agent.last_name };
                    }
                    $el.residentSettings.forwarding_address = response.data.forwarding_address ? response.data.forwarding_address : response.data.address;
                    if (response.data.current_status === 'Move Out') {
                        $el.residentSettings.resident_deposit_amount = response.data.unit.past_resident_unit_lease.resident_deposit_amount;
                    } else {
                        $el.residentSettings.resident_deposit_amount = response.data.unit.unit_lease.resident_deposit_amount;
                    }
                    Event.$emit('update-resident-security-deposit', $el.residentSettings.resident_deposit_amount);
                    axios.post('/prototype/person/residents/get-resident-detail', { id: $el.person.id, residentId: $el.resident.id }).then(function (response) {
                        if (response.data) {
                            if (response.data.vehicles) {
                                $el.vehicles = response.data.vehicles;
                            }
                            if (response.data.occupants) {
                                $el.occupants = response.data.occupants;
                            }
                            if (response.data.CoApplicants) {
                                $el.CoApplicants = response.data.CoApplicants;
                                $el.CoApplicants = $el.CoApplicants.map(function (applicant) {
                                    applicant.birth_date = moment(applicant.birth_date).format("MM/DD/YYYY");
                                    return applicant;
                                });
                            }
                            if (response.data.pets) {
                                $el.pets = response.data.pets;
                            }
                            if (response.data.services) {
                                $el.services = response.data.services;
                            }
                        }
                    });
                }
            });
        },
        updateLateFeeFlag: function updateLateFeeFlag() {
            var _this5 = this;

            this.flagsLoading = true;
            axios.post('/prototype/person/residents/update-late-fee-flag/' + this.resident.id, {
                do_not_renew_lease: this.resident.do_not_renew_lease,
                eligible_for_late_fees: this.resident.eligible_for_late_fees,
                electronic_utility_billing: this.resident.electronic_utility_billing
            }).then(function (response) {
                if (response.data) {
                    _this5.flagsLoading = false;
                }
            });
        },
        updateServices: function updateServices() {
            var _this6 = this;

            var $el = this;
            this.editService = false;
            this.servicesLoading = true;
            var payLoad = [];
            this.services.map(function (service) {
                if (service.selected) {
                    payLoad.push(service.service);
                }
            });
            axios.post('/prototype/person/residents/saveServices', { id: $el.resident.id, services: payLoad, rental_policy: $el.rental_policy }).then(function (response) {
                if (response.data) {
                    _this6.servicesLoading = false;
                    $el.services = response.data;
                }
            });
        },
        deleteLine: function deleteLine(idx) {
            this.CoApplicants.splice(idx, 1);
        },
        deleteOccupant: function deleteOccupant(idx) {
            this.occupants.splice(idx, 1);
        },
        deletePet: function deletePet(idx) {
            this.pets.splice(idx, 1);
        },
        canUserSeeFullSsn: function canUserSeeFullSsn() {
            return this.allowedAdminUserRoles.includes(window.validator.role());
        },
        updateLease: function updateLease() {
            var $el = this;
            this.leaseLoading = true;
            axios.post('/prototype/person/residents/update-lease', this.lease).then(function (response) {
                if (response.data) {
                    $el.leaseLoading = false;
                    $el.editLease = false;
                    $el.lease = response.data;
                    $el.lease.move_in_date = moment($el.lease.move_in_date).format("MM/DD/YYYY");
                    Event.$emit('reload-resident');
                    Event.$emit('resident-list-dashboard-updated');
                }
            });
        },
        canUserEditSecurityDeposit: function canUserEditSecurityDeposit() {
            if (this.residentSettings.current_status === 'Move Out') {
                return this.rolesForPastResident.includes(window.validator.role());
            } else {
                return this.rolesForActiveResident.includes(window.validator.role());
            }
        },
        addArNotes: function addArNotes() {
            var _this7 = this;

            this.validator.setRules(this.arNotesValidation).validate();

            if (this.validator.fails()) {
                return;
            }
            this.arLoading = true;
            axios.post('/prototype/resident/add-ar-notes', { 'id': this.resident.id, 'ar_notes': this.ar_notes }).then(function (response) {
                _this7.arAudit = response.data.audit;
                _this7.ar_notes = response.data.resident.ar_notes;
                _this7.editArNotes = false;
                _this7.arLoading = false;
                _this7.emptyArNotes = false;
            });
        },
        addGeneralNotes: function addGeneralNotes() {
            var _this8 = this;

            this.validator.setRules(this.generalNotesValidation).validate();

            if (this.validator.fails()) {
                return;
            }
            this.generalLoading = true;
            axios.post('/prototype/resident/add-general-notes', { 'id': this.resident.id, 'general_notes': this.general_notes }).then(function (response) {
                _this8.generalAudit = response.data.audit;
                _this8.general_notes = response.data.resident.general_notes;
                _this8.editGeneralNotes = false;
                _this8.generalLoading = false;
                _this8.emptyGeneralNotes = false;
            });
        }
    },
    computed: {
        leasingAgents: function leasingAgents() {

            return this.users.map(function (u) {
                return {
                    label: '(' + u.id + ') ' + u.first_name + ' ' + u.last_name,
                    id: '' + u.id
                };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentDetailsSettings.vue
// module id = AeoL
// module chunks = 0 1